import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import PropTypes from 'prop-types'
import SwiperCore, {
  EffectCoverflow,
  Keyboard,
  Mousewheel,
  Navigation,
  Pagination,
} from 'swiper'

import { useStores } from '../../helpers/common'
import ReceptionMusicModalContainer from './ReceptionMusicModalContainer'

import '../../themes/pages/static-reception.less'

SwiperCore.use([EffectCoverflow, Keyboard, Mousewheel, Navigation, Pagination])

const StaticReceptionContainer = ({ match }) => {
  const {
    bookingStore: {
      selectCityByCityName,
      createContext,
      getRegionsAndCities,
      setIsDisabledCityDropdown,
    },
  } = useStores()

  const initializeData = async () => {
    const {
      params: { cityname },
    } = match

    setIsDisabledCityDropdown(true)
    await getRegionsAndCities()
    await createContext()
    await selectCityByCityName(cityname, false)
  }

  useEffect(() => {
    initializeData()

    return () => setIsDisabledCityDropdown(false)
  }, [])

  return (
    <div id="qbDetails">
      <ReceptionMusicModalContainer
        wrapClassName="static-reception"
        getContainer="body"
      />
    </div>
  )
}

StaticReceptionContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      cityname: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export default observer(StaticReceptionContainer)
